import { tv } from "tailwind-variants";
const statusBannerVariants = tv({
    slots: {
        baseSlot: 'flex flex-row items-center rounded-lg px-4 py-3',
        contentCtaSlot: 'flex min-w-0 flex-1 flex-col justify-between @min-[608px]:flex-row',
        iconSlot: 'mr-3 flex flex-row items-center justify-center',
        headingSlot: 'text-heading6',
        captionSlot: 'text-body2',
        ctaSlot: 'flex h-auto flex-row items-center justify-end gap-1 @max-[608px]:mt-1 @max-[608px]:w-full @min-[608px]:ml-3',
        headingContentSlot: 'flex max-w-[720px] flex-col gap-1',
        iconContentWrapper: 'flex flex-row items-center',
        dismissSlot: '-my-1 -mr-2 ml-2 flex shrink-0 items-center'
    },
    variants: {
        palette: {
            neutral: {},
            info: {},
            success: {},
            caution: {},
            error: {}
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                baseSlot: 'border-1 border-neutral-4 bg-neutral-1 text-neutral-13',
                iconSlot: '*:text-neutral-8'
            }
        },
        {
            palette: 'info',
            emphasis: 'regular',
            class: {
                baseSlot: 'border-1 border-primary-4 bg-primary-1 text-primary-13',
                iconSlot: '*:text-primary-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'regular',
            class: {
                baseSlot: 'border-1 border-success-4 bg-success-1 text-success-13',
                iconSlot: '*:text-success-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                baseSlot: 'border-1 border-caution-4 bg-caution-1 text-caution-13',
                iconSlot: '*:text-caution-9'
            }
        },
        {
            palette: 'error',
            emphasis: 'regular',
            class: {
                baseSlot: 'border-1 border-error-4 bg-error-1 text-error-13',
                iconSlot: '*:text-error-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                baseSlot: 'border-1 border-neutral-2 bg-neutral-2 text-neutral-13',
                iconSlot: '*:text-neutral-10'
            }
        },
        {
            palette: 'info',
            emphasis: 'medium',
            class: {
                baseSlot: 'border-1 border-primary-3 bg-primary-3 text-primary-13',
                iconSlot: '*:text-primary-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'medium',
            class: {
                baseSlot: 'border-1 border-success-3 bg-success-3 text-success-13',
                iconSlot: '*:text-success-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                baseSlot: 'border-1 border-caution-3 bg-caution-3 text-caution-13',
                iconSlot: '*:text-caution-9'
            }
        },
        {
            palette: 'error',
            emphasis: 'medium',
            class: {
                baseSlot: 'border-1 border-error-3 bg-error-3 text-error-13',
                iconSlot: '*:text-error-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                baseSlot: 'border-1 border-neutral-10 bg-neutral-10 text-neutral-1',
                iconSlot: '*:text-benefit-1'
            }
        },
        {
            palette: 'info',
            emphasis: 'bold',
            class: {
                baseSlot: 'border-1 border-primary-9 bg-primary-9 text-primary-1',
                iconSlot: '*:text-primary-1'
            }
        },
        {
            palette: 'success',
            emphasis: 'bold',
            class: {
                baseSlot: 'border-1 border-success-9 bg-success-9 text-success-1',
                iconSlot: '*:text-success-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                baseSlot: 'border-1 border-caution-7 bg-caution-7 text-caution-13',
                iconSlot: '*:text-caution-13'
            }
        },
        {
            palette: 'error',
            emphasis: 'bold',
            class: {
                baseSlot: 'border-1 border-error-9 bg-error-9 text-error-1',
                iconSlot: '*:text-error-1'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'medium',
        palette: 'neutral'
    }
});
export { statusBannerVariants };
